import { FC, useState, useLayoutEffect } from "react";
import { toast } from "react-toastify";

import { useAppDispatch } from "../../../../assets/hooks/hooks";
import { useGetHistoryMigrationLicenseQuery } from "../../../../redux/RTKQuery/api";
import { uiSlicedActions } from "../../../../redux/ui-slice";
import { FetchLicenseHistory } from "../../LicenseKeyHistory/historyModel";
import LicenseKeyHistory from "../../LicenseKeyHistory/LicenseKeyHistory";
import { License, MigratedLicenseKeysData } from "../model";

const LicenseKeysMigratedSubRow: FC<MigratedLicenseKeysData> = ({
    licenseKey,
}) => {
    const [oneLicense] = useState<License["licenseKey"] | undefined>(
        licenseKey
    );
    const [licenseHistory, setData] = useState<FetchLicenseHistory[]>([]);
    const [hasFetched, setHasFetched] = useState(false);

    const dispatch = useAppDispatch();

    const {
        data: licenceHistory,
        isLoading: isLoadingLicenceHistory,
        isSuccess: isSuccessLicenceHistory,
        isError: isErrorLicenceHistory,
    } = useGetHistoryMigrationLicenseQuery(
        { licenseKey: oneLicense },
        { skip: hasFetched }
    );

    useLayoutEffect(() => {
        if (isSuccessLicenceHistory && licenceHistory) {
            setData(licenceHistory);
            setHasFetched(true);
        }
        if (isErrorLicenceHistory) {
            toast.error("Error fetching license history");
        }
    }, [licenceHistory, isSuccessLicenceHistory, isErrorLicenceHistory]);

    useLayoutEffect(() => {
        dispatch(
            uiSlicedActions.setLoading(
                isLoadingLicenceHistory ? "pending" : "hidden"
            )
        );
    }, [isLoadingLicenceHistory, dispatch]);

    return (
        <div className="license_keys_migrated_sub_row">
            <LicenseKeyHistory licenseHistory={licenseHistory} />
        </div>
    );
};

export default LicenseKeysMigratedSubRow;
